import { getCookie } from 'src/utils/cookies'

export function getFacebookParams() {
  const fbc = getCookie('_fbc') ?? ''
  const fbp = getCookie('_fbp') ?? ''

  return {
    fbc,
    fbp,
  }
}
